<template>
  <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.period')}]">
    <div v-if="hasFieldErrors('dataForm.data.period')">
      <span v-for="error in getFieldErrors('dataForm.data.period')" class="help-block" :key="error">{{ error }}</span>
    </div>
    <label v-else :for="'invoice_Period'">
      <span class="required">*</span> {{ 'dictionary.invoice.period' | i18nText(pDictionary) }}:
    </label>
    <div class="clearfix">
      <div class="pull-left" style="width: 45%;">
        <div class="input-group ">
          <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
          <input ref="periodStartDateText"
                 type="text"
                 :id="'invoice_PeriodStartDateText'"
                 :name="'dataForm.data.period.startDateText'"
                 v-model="period.startDateText"
                 :placeholder="'dictionary.format.date.hint' | i18nText(pDictionary)"
                 class="form-control datepicker periodStartDateText"
                 size="10" maxlength="10"
                 autocomplete="off" :readonly="pReadOnly">
        </div>
      </div>
      <div class="pull-left text-center" style="width: 10%;">
        <p class="form-control-static">To</p>
      </div>
      <div class="pull-left" style="width: 45%;">
        <div class="input-group pull-left">
          <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
          <input ref="periodEndDateText"
                 type="text"
                 :id="'invoice_PeriodEndDateText'"
                 :name="'dataForm.data.period.endDateText'"
                 v-model="period.endDateText"
                 :placeholder="'dictionary.format.date.hint' | i18nText(pDictionary)"
                 class="form-control datepicker periodEndDateText"
                 size="10" maxlength="10"
                 autocomplete="off" :readonly="pReadOnly">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FormMixin from "@/mixins/form-mixin";

export default {
  name: "InvoiceSaveFormInvoiceSectionPeriod",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    value: {
      type: Object,
      default: function () {
        return {
          startDateText: '',
          endDateText: ''
        }
      }
    },
    pReadOnly: Boolean,
    pMinDate: String,
    pMaxDate: String
  },
  data: function () {
    return {
      period: this.value
    }
  },
  watch: {
    period: function () {
      this.$emit('input', this.period)
    },
    pMinDate: function(newMinDate) {
      let $periodStartDateText = $(this.$refs.periodStartDateText);
      $periodStartDateText.datepicker('option', { minDate: newMinDate });

      let $periodEndDateText = $(this.$refs.periodEndDateText);
      $periodEndDateText.datepicker('option', { minDate: newMinDate });
    },
    pMaxDate: function(newMaxDate) {
      let $periodStartDateText = $(this.$refs.periodStartDateText);
      $periodStartDateText.datepicker('option', { maxDate: newMaxDate });

      let $periodEndDateText = $(this.$refs.periodEndDateText);
      $periodEndDateText.datepicker('option', { maxDate: newMaxDate });
    }
  },
  mounted: function () {
    let _component = this;

    if(!_component.pReadOnly)
    {
      // Init PeriodStartDate.
      let $periodStartDateText = $(this.$refs.periodStartDateText);
      $periodStartDateText.initFromDatePicker(
          {
            dateElId: $periodStartDateText.attr('id'),
            linkDateElId: null,
            minDate: _component.pMinDate,
            maxDate: _component.pMaxDate,
            bs3: true,
            f: function (selectedDate) {
              _component.$data.period.startDateText = selectedDate;
              _component.$refs.periodStartDateText.dispatchEvent(new Event('change'));
            }, noWeekends: false
          });

      // Init PeriodEndDate.
      let $periodEndDateText = $(this.$refs.periodEndDateText);
      $periodEndDateText.initFromDatePicker(
          {
            dateElId: $periodEndDateText.attr('id'),
            linkDateElId: $periodStartDateText.attr('id'),
            minDate: _component.pMinDate,
            maxDate: _component.pMaxDate,
            bs3: true,
            f: function (selectedDate) {
              _component.$data.period.endDateText = selectedDate;
              _component.$refs.periodEndDateText.dispatchEvent(new Event('change'));
            }, noWeekends: false
          });
    }
  }
}
</script>

<style scoped>

</style>